export class ResetPasswordModel {
    firstName: string;
    lastName: string;
    emailAddress: string;
    captchaId: string;
    captchaText: string;
}



// WEBPACK FOOTER //
// ./src/app/models/reset.password.model.ts